// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { addYears, startOfMonth } from "date-fns";

/** Earliest year a store's install or go-live date picker offers — the first rollouts. */
export const STORE_DATE_FROM_YEAR = 2017;

/**
 * Last month a store's install or go-live date picker can reach: the month a year from today, in full.
 * Worked out on every call, so the bound rolls forward with the calendar rather than freezing at build
 * time. Rollout plans run months ahead, past the year end the picker would otherwise stop at.
 */
export function storeDateToMonth(today: Date = new Date()): Date {
  return startOfMonth(addYears(today, 1));
}

/**
 * Whether a store would go live before its system is installed — never valid. Same day is fine.
 * Both are `yyyy-MM-dd`, so string order is date order; a missing date can't conflict.
 */
export function isGoLiveBeforeInstall(installDate: string | null | undefined, goLiveDate: string | null | undefined) {
  return !!installDate && !!goLiveDate && goLiveDate < installDate;
}
